<template>
  <v-container fluid>
    <div class="toolbar d-flex flex-row justify-space-between align-center elevation-3 mb-3">
      <span>
        Sync Order Error
      </span>
      <div class="d-flex">
        <v-text-field
          v-model.trim="inputSearch"
          hide-details
          label="Search"
          append-icon="mdi-magnify"
          dense
          outlined
          @keydown.enter="getItems(true)">
        </v-text-field>
      </div>
    </div>
    <v-row class="px-2">
      <v-col
        cols="12"
        :md="selectItem && showDetail ? '8' : '12'">
        <div class="card-container elevation-3">
          <v-tabs
            v-model="tab"
            class="mb-3">
            <v-tab
              v-for="(item, index) in tabs"
              :key="`${item.label}-${index}`">
              {{ item.label }}
            </v-tab>
          </v-tabs>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :items-per-page="options.itemsPerPage"
            :server-items-length="total"
            :loading="loading"
            :item-class="rowClass"
            :footer-props="{'items-per-page-options': [15, 25, 50, 100]}"
            @update:options="getItems()">
            <template #[`item.orderId`]="{ item }">
              <div style="display: flex; align-items: center;">
                <div>
                  <v-icon
                    v-if="item.resolved"
                    color="success"
                    title="resolved">
                    mdi-check-circle-outline
                  </v-icon>
                  <v-icon
                    v-else
                    title="need resolve"

                    color="error">
                    mdi-close-circle-outline
                  </v-icon>
                </div>
                <div class="ml-2 pa-2">
                  <div>
                    <b> Tiktok Order ID </b>{{ item.tiktokOrderId }}
                  </div>
                  <div>
                    <b> Operation </b>{{ item.operation }}
                  </div>
                  <div>
                    <b> Shop </b>{{ item.shop.name }}
                  </div>
                </div>
              </div>
            </template>
            <template #[`item.createdAt`]="{ item }">
              {{ item.createdAt | dateTimeUserFormat() }}
            </template>
            <template #[`item.retry`]="{ item }">
              <span>{{ item.reproduceCount || 0 }}/3</span>
              <v-chip
                v-if="isUrgent(item)"
                x-small
                color="error"
                class="ml-1">
                URGENT
              </v-chip>
              <v-chip
                v-if="item.escalatedAt"
                x-small
                color="error"
                class="ml-1">
                Escalated
              </v-chip>
              <div class="caption grey--text">
                {{ item.lastRetryAt | dateTimeUserFormat() }}
              </div>
            </template>
            <template #[`item.option`]="{ item }">
              <span>
                <v-btn
                  link
                  icon
                  x-small
                  :loading="reproducingId === item.id"
                  :disabled="!!reproducingId"
                  class="mr-2"
                  @click="reproduce(item)">
                  <v-icon color="success">
                    mdi-reproduction
                  </v-icon>
                </v-btn>
              </span>
              <v-btn
                link
                icon
                x-small
                :disabled="showDetail && selectItem && selectItem.id === item.id"
                @click="showItemDetail(item)">
                <v-icon>
                  mdi-magnify
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-col>
      <v-col
        v-if="selectItem && showDetail"
        cols="12"
        md="4">
        <div class="card-container elevation-3">
          <div>
            <h2 class="text-bold">
              {{ selectItem.tiktokOrderId }}
            </h2>
            <p class="mb-0">
              <b>Operation : </b>{{ selectItem.operation }}
            </p>
            <div class="mb-4">
              <p class="mb-0">
                <b>Date : </b>{{ selectItem.createdAt | dateTimeUserFormat() }}
              </p>
              <p
                v-if="selectItem.resolvedBy"
                class="mb-0">
                <b>Resolved By : </b>
                <v-chip
                  x-small
                  :color="resolvedByColor(selectItem.resolvedBy)"
                  text-color="white">
                  {{ selectItem.resolvedBy }}
                </v-chip>
              </p>
              <p
                v-if="selectItem.escalatedAt"
                class="mb-0">
                <b>Escalated At : </b>{{ selectItem.escalatedAt | dateTimeUserFormat() }}
              </p>
            </div>
            <h3> Shop </h3>
            <p class="mb-0">
              <b>ID : </b>{{ selectItem.shop.shopId }} ({{ selectItem.shop.sellerType }})
            </p>
            <p class="mb-0">
              <b>Name : </b>{{ selectItem.shop.name }}
            </p>
            <p>
              <b>Region : </b>{{ selectItem.shop.region }}
            </p>
            <h3> Error Message </h3>
            <span class="mb-0">{{ selectItem.errorMessage }}</span>
            <div style="border: 1px solid #000;">
              <json-viewer
                :value="selectItem.errorDetails"
                :expand-depth="2"
                copyable />
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TiktokProvider from '@/resources/TiktokProvider.js'

const TiktokService = new TiktokProvider()
export default {
  data () {
    return {
      showDetail: false,
      selectItem: null,
      tab: 0,
      tabs: [
        { label: 'All', params: {} },
        { label: 'Unresolved', params: { resolved: 'false' } },
        { label: 'Needs Attention', params: { escalated: 'true', resolved: 'false' } }
      ],
      headers: [
        {
          text: 'Order Id',
          value: 'orderId',
          sortable: false
        },
        {
          text: 'Date',
          value: 'createdAt',
          sortable: false
        },
        {
          text: 'Error Message',
          value: 'errorMessage',
          width: '400px',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Retry',
          value: 'retry',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Option',
          value: 'option',
          sortable: false,
          align: 'center'
        }
      ],
      items: [],
      inputSearch: '',
      total: 0,
      options: {
        page: 1,
        itemsPerPage: 25,
        sortBy: ['createdAt'],
        sortDesc: [true]
      },
      loading: false,
      reproducingId: null
    }
  },
  watch: {
    'query.page': {
      handler () {
        this.getItems()
      },
      deep: true
    },
    tab () {
      this.getItems(true)
    }
  },
  async mounted () {
    await this.getItems(true)
  },
  methods: {
    async showItemDetail (item) {
      this.selectItem = item
      this.showDetail = true
    },
    isUrgent (item) {
      return item.operation === 'CANCEL_ORDER' && (!!item.escalatedAt || /not voidable/i.test(item.errorMessage || ''))
    },
    rowClass (item) {
      return this.isUrgent(item) ? 'row-urgent' : ''
    },
    resolvedByColor (value) {
      if (value === 'OBSOLETE') return 'warning'
      if (value === 'SELF_HEALED') return 'grey'
      return 'success'
    },
    async reproduce (item) {
      try {
        this.reproducingId = item.id
        await TiktokService.reproduce({
            logId: item.id
        })
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: 'Success',
          type: 'success'
        })
      } catch (error) {
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        await this.getItems()
        this.reproducingId = null
      }
    },
    async getItems (isClear = false) {
      try {
        this.loading = true

        if (isClear) {
          this.items = []
          this.options.page = 1
        }

        const { data } = await TiktokService.getTiktokOrderError({
            page: this.options.page,
            limit: this.options.itemsPerPage,
            sortBy: this.options.sortBy[0],
            sortOrder: this.options.sortDesc[0] ? 'desc' : 'asc',
            search: this.inputSearch,
            ...this.tabs[this.tab].params
          })

        this.items = (data?.results || [])
        this.total = data?.total || 0
      } catch (error) {
        console.error('getItems', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.toolbar {
  position: sticky;
  top: 70px;
  left: 0;
  width: 100%;
  z-index: 5;
  background-color: #fff;
  padding: 1.25rem 1.875rem;
  border-radius: 0.625rem;
}
.toolbar span {
  font-weight: bold;
  font-size: 1.25rem;
}
.card-container {
  padding: 1.25rem 1.875rem;
  background-color: #fff;
  border-radius: 0.625rem;
  margin-top: 1.25rem;
  height: calc(100vh - 220px);
  overflow: auto;
}
.card-title {
  font-weight: bold;
  font-size: 1.35rem;
}
.paginate-container {
  padding: 0.25rem;
  background-color: #fff;
  border-radius: 1rem;
  margin-top: 0.5rem;
}
</style>

<style>
.search-box .v-input__control {
  max-width: unset !important;
  min-height: 28px !important;
  max-height: 28px !important;
}
.search-box .v-input__slot {
  max-width: unset !important;
  min-height: 28px !important;
  max-height: 28px !important;
}
.row-urgent {
  background-color: #ffebee !important;
}
</style>
